import { gql } from '@apollo/client';

const userFragment = gql`
  fragment User on User {
    id
    phone
    email
    idVerificationStatus
  }
`;

const getCurrentUser = gql`
  query GetCurrentUser {
    currentUser {
      ...User
    }
  }
  ${userFragment}
`;

export default getCurrentUser;
